import { render, staticRenderFns } from "./AdminMessage.vue?vue&type=template&id=8a53b48a&"
import script from "./AdminMessage.vue?vue&type=script&lang=js&"
export * from "./AdminMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports